import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const impactAssessmentStyles = makeStyles((theme: Theme) =>
    createStyles({
        main: {
            padding: "30px 50px 30px 50px",
        },
        paper: {
            boxShadow: "0px 4px 10px rgba(110, 102, 102, 0.2)",
            padding: "10px 0px 20px 0px",
            borderRadius: "0px",
            marginTop: "20px",
            marginLeft: "40px",
        },
        icon: {
            marginLeft: "10px",
            cursor: "pointer",
        },
        hide: {
            display: "none",
        },
        title: { display: "flex" },
        tooltip: {
            boxShadow: "0px 4px 10px rgba(110, 102, 102, 0.2)",
            padding: "20px",
            borderRadius: "0px",
            maxWidth: "200px",
            maxHeight: "400px",
            position: "relative",
            left: "100%",
            top: -280,
            // top: -70,
        },
        tooltipText: { fontSize: "14px", lineHeight: "16.52px" },
        tooltipTitle: {
            fontSize: "18px",
            lineHeight: "18px",
            fontWeight: 500,
        },
        divider: {
            margin: "30px 0px 30px 0px",
        },
    })
);
